import { ROOM_STATE } from 'services/webSockets/roomState/constants'
import {
    setIsInteractionMode,
    setClassTitleAndRoomType,
    handlePIP,
    handleRoomState,
    setStudentsCount,
    handleFullScreenToggle,
    updateParticipantInfo,
    updateNetworkBandwidthSaverMode,
    updateIsTeacherPresent,
    updateIsActivityMode,
} from 'store/actions/Room'
import { setRoomData } from 'store/thunks/Room'

import { dispatchSendSocketMessage } from './WebSocket'

import store from '../index'

const { dispatch } = store

export const dispatchSetIsInteractionMode = mood =>
    dispatch(setIsInteractionMode(mood))

export const dispatchSetRoomData = async ({ roomName, random, userId }) =>
    await dispatch(setRoomData({ roomName, random, userId }))

export const dispatchSetClassTitleAndRoomType = classTitle =>
    dispatch(setClassTitleAndRoomType(classTitle))

export const dispatchOpenPIP = () => dispatch(handlePIP(true))
export const dispatchClosePIP = () => dispatch(handlePIP(false))
export const dispatchHandleRoomState = room => dispatch(handleRoomState(room))

export const dispatchSetStudentsCount = count =>
    dispatch(setStudentsCount(count))

export const dispatchHandleFullScreenToggle = isTeacherFullScreen =>
    dispatch(handleFullScreenToggle(isTeacherFullScreen))

export const dispatchUpdateParticipantInfo = (...payload) =>
    dispatch(updateParticipantInfo(...payload))

export const dispatchRoomState = state =>
    dispatchSendSocketMessage({
        action: ROOM_STATE,
        state,
    })

export const dispatchUpdateIsTeacherPresent = value =>
    dispatch(updateIsTeacherPresent(value))

export const dispatchUpdateIsActivityMode = value =>
    dispatch(updateIsActivityMode(value))
